export interface ServiceWorkerRegistrationContext {
  serviceWorkerSupported: boolean
  viteDevClientPresent: boolean
}

/**
 * Register for built/previewed copies, regardless of the container's inherited
 * NODE_ENV. The Vite development client is the runtime signal that caching
 * should stay disabled while source modules are being edited.
 */
export const shouldRegisterServiceWorker = ({
  serviceWorkerSupported,
  viteDevClientPresent,
}: ServiceWorkerRegistrationContext): boolean => serviceWorkerSupported && !viteDevClientPresent

